module.exports = __webpack_public_path__ + "static/img/bcg2.dc664f90.webp";